import type { CombinedError, UseQueryExecute } from "urql"
import { useQuery } from "urql"

import type {
  Query,
  WarehouseArea,
  WarehouseAreaGetSuccess,
  WarehouseAreaQueryGetArgs,
} from "@/graphql/codegen/graphql"
import { WarehouseDetailsDocument } from "@/graphql/codegen/graphql"

interface UseGetWarehouseReturn {
  warehouse: WarehouseArea | null
  isFetching: boolean
  error?: CombinedError
  refetch: UseQueryExecute
}

export const useGetWarehouse = (warehouseAreaId: string | null): UseGetWarehouseReturn => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<Pick<Query, "warehouseArea">, WarehouseAreaQueryGetArgs>(
    {
      query: WarehouseDetailsDocument,
      variables: { input: { warehouseAreaId: warehouseAreaId ?? "" } },
      pause: !warehouseAreaId,
    }
  )

  return {
    warehouse: (data?.warehouseArea.get as WarehouseAreaGetSuccess)?.warehouseArea ?? null,
    isFetching: fetching,
    error,
    refetch: reexecuteQuery,
  }
}
